module.exports = __webpack_public_path__ + "static/media/aline.dc56b1cb.png";